export default __webpack_public_path__ + "static/media/Clean-Connect-Logo.a3656253.jpg";